import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import IndustriesFeature from "@/components/home/IndustriesFeature";
import FinalCTA from "@/components/home/FinalCTA";

export default function Industries() {
  return (
    <>
      <SEO
        title="Industries | All Data Tech"
        description="Data and AI solutions for financial services, healthcare, retail, manufacturing, logistics and technology."
        path="/industries"
      />
      <PageHero
        eyebrow="Industries"
        title={<>Intelligence built for the way <span className="text-gradient">your industry works.</span></>}
        sub="We adapt our data engineering, analytics and AI approach to the realities and constraints of your sector."
      />
      <IndustriesFeature />
      <FinalCTA />
    </>
  );
}
